// TODO: unit test
const parseEnumOptions = enumObject => Object.values(enumObject).map(item => ({
  key: item,
  value: item,
  text: item,
}));

export default parseEnumOptions;
